<template>
  <form v-loading="`<i class='ti ti-refresh ti-spin'></i>`" @submit.prevent="submit">
    <vue-form-generator
      :schema="schema"
      :model="model"
      :options="{ validationAfterLoad: true, validationAfterChanged: true }"
      class="change-password-form"
      tag="div"
    />
    <div v-if="!isSamePassword" class="error">
      * {{ $t('form.password_repeat_error') }}
    </div>
    <b-button
      class="btn-fixed-bottom"
      type="submit"
      variant="primary"
      block
    >
      {{ $t('actions.save') }}
    </b-button>
  </form>
</template>

<script>
  import VueFormGenerator from '@triotech/vue-core/src/vendor/vue-form-generator';

  export default {
    name: 'ChangePassword',
    components: {
      'vue-form-generator': VueFormGenerator.component,
    },
    props: {
      to: {
        type: Object,
        default: () => ({}),
      },
      modelPassword: {
        type: Object,
        default: () => ({}),
      },
      toLogin: {
        type: Boolean,
        default: false,
      },
      styleBtn: {
        type: String,
        default: '',
      },
      token: {
        type: String,
        default: null,
      },
      withOptionalFields: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      const minimumLength = 8;
      return {
        minimumLength,
        model: this.modelPassword,
        schemaOptionalFields: [],
        schema: {
          fields: [{
            default: '',
            disabled: false,
            featured: '',
            id: 'password',
            inputType: 'password',
            label: this.$t('password.new_pwd'),
            maxlength: null,
            model: 'password',
            placeholder: this.$t('password.new_pwd'),
            readonly: false,
            min: minimumLength,
            minlength: minimumLength,
            required: true,
            type: 'input',
            hint: this.$t('validation.password', { min_length: minimumLength }),
            autocomplete: 'new-password',
          }, {
            default: '',
            disabled: false,
            featured: '',
            id: 'password_confirm',
            inputType: 'password',
            label: this.$t('password.repeat_pwd'),
            maxlength: null,
            model: 'password_confirm',
            placeholder: this.$t('password.repeat_pwd'),
            readonly: false,
            min: minimumLength,
            minlength: minimumLength,
            required: true,
            type: 'input',
            hint: this.$t('validation.password', { min_length: minimumLength }),
            autocomplete: 'new-password',
          }],
        },
      };
    },
    computed: {
      route() {
        return this.$config.get('subendpoint');
      },
      resettingModel() {
        return {
          triotech_fos_user_resetting: {
            plainPassword: this.model.password || '',
          },
        };
      },
      isSamePassword() {
        return (this.model.password_confirm || '') === (this.model.password || '');
      },
    },
    mounted() {
      if (this.withOptionalFields) {
        const { schema } = this;

        this.schemaOptionalFields.push({
          default: '',
          disabled: false,
          featured: '',
          id: 'old_password',
          inputType: 'password',
          label: this.$t('password.old_pwd'),
          maxlength: null,
          model: 'old_password',
          placeholder: this.$t('password.old_pwd'),
          readonly: false,
          min: this.minimumLength,
          minlength: this.minimumLength,
          required: true,
          type: 'input',
          hint: this.$t('validation.password', { min_length: this.minimumLength }),
          autocomplete: 'current-password',
        });

        if (this.$helper.isLegacy) {
          this.schemaOptionalFields.push({
            type: 'input',
            disabled: false,
            id: 'email',
            inputType: 'email',
            label: this.$t('form.email'),
            maxlength: null,
            model: 'email',
            placeholder: this.$t('form.email'),
            readonly: false,
            required: true,
            autocomplete: 'username email',
          });
        }
        this.schemaOptionalFields.forEach((el) => {
          schema.fields.unshift(el);
        });

        return schema;
      }

      return this.schema;
    },
    methods: {
      submit() {
        const route = this.user() ? `${this.route}user/me/change_password` : `public/resetting/reset/${this.token}`;
        const model = this.user() ? this.model : this.resettingModel;

        return this.$ajax.post(route, model).then((data) => {
          if (data.status === 'ok') {
            this.$notify({
              title: this.$t('flashes.change_password.title'),
              text: this.$t('flashes.change_password.success'),
              type: 'success',
            });

            if (this.user()) {
              const oauth = this.oauth();
              oauth.user.email = model.email;

              this.set({ oauth });

              if (this.user().popup) {
                this.$helper.popupHide();
              }
            }

            if (this.toLogin) {
              // if :to is defined, use it.
              if (!this._.isEmpty(this.to)) {
                this.$router.push(this.to);
              } else {
                this.$router.push({ name: 'login' });
              }
            }
          }
        }).catch((err) => {
          let text = null;
          if (err.response && err.response.status === 500) {
            text = 'error.server_error';
          } else if (err.response.data.error) {
            text = err.response.data.error;
          }

          this.$notify({
            text: this.$t(text),
            type: 'error',
          });
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';

  .error {
    color: $danger;
  }
</style>
